import { isEnvironmentFlagTruthy } from './nav/flags';
import { isRevenueNavigationPath } from './nav/utils/isRevenueEnvironment';
import { Userpilot } from 'userpilot';

const BILLING_USERPILOT_KEY = 'NX-ece3c95f';
const ONEID_USERPILOT_KEY = 'NX-6d9ccacc';
const REVENUE_USERPILOT_KEY = 'NX-d5356b8a';

function userPilotEnabled(location, localStorage): boolean | null {
  let explicitPilot: boolean | null = null;
  const pilotFalse = location.indexOf('pilot=false') > -1;
  if (pilotFalse) {
    explicitPilot = false; // Set explicitPilot to false if passed as a parameter
  }

  const pilotTrue = location.indexOf('pilot=true') > -1;
  if (pilotTrue) {
    explicitPilot = true; // Set explicitPilot to true if passed as a parameter
  }

  if (explicitPilot === true || explicitPilot === false) {
    if (localStorage) {
      localStorage.setItem('ZNavUserpilot', JSON.stringify(explicitPilot));
    }
  } else {
    const localStorageOverride =
      localStorage && localStorage.getItem('ZNavUserpilot');
    if (localStorageOverride !== null) {
      explicitPilot = JSON.parse(localStorageOverride);
    }
  }

  return explicitPilot;
}

function initialize() {
  const explicitPilot = userPilotEnabled(
    document.location.href,
    window.localStorage,
  );
  const environmentDefault = isEnvironmentFlagTruthy({
    DEVELOPMENT: true,
    STAGING: true,
    PREPROD: true,
    SANDBOX: true,
    PRODUCTION: true,
  });

  if (explicitPilot || (environmentDefault && explicitPilot != false)) {
    try {
      const isOneIDEnv = document.location.host.startsWith('one');
      const isRevenueEnv = isRevenueNavigationPath(document.location.pathname);
      const USERPILOT_KEY =
        isOneIDEnv && !isRevenueEnv
          ? ONEID_USERPILOT_KEY
          : isRevenueEnv
          ? REVENUE_USERPILOT_KEY
          : BILLING_USERPILOT_KEY;
      Userpilot.initialize(USERPILOT_KEY);

      // Variables are mounted in the userpilotFunctions.tsx
    } catch (Exception) {
      console.warn('Unable to load UserPilot');
    }
  }
}

initialize();
